"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.rhMessages = exports.ab0Messages = exports.Rh = exports.Ab0 = void 0;
const schema_1 = require("../../../schema");
var Ab0;
(function (Ab0) {
    Ab0["AB0_A"] = "ab0_a";
    Ab0["AB0_AVAR"] = "ab0_avar";
    Ab0["AB0_B"] = "ab0_b";
    Ab0["AB0_BVAR"] = "ab0_bvar";
    Ab0["AB0_AB"] = "ab0_ab";
    Ab0["AB0_0"] = "ab0_0";
})(Ab0 || (exports.Ab0 = Ab0 = {}));
var Rh;
(function (Rh) {
    Rh["RH_POSITIVE"] = "rh_positive";
    Rh["RH_NEGATIVE"] = "rh_negative";
})(Rh || (exports.Rh = Rh = {}));
exports.ab0Messages = {
    [Ab0.AB0_A]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_A",
        defaultMessage: "A"
    },
    [Ab0.AB0_AVAR]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_AVAR",
        defaultMessage: "A variant"
    },
    [Ab0.AB0_B]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_B",
        defaultMessage: "B"
    },
    [Ab0.AB0_BVAR]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_BVAR",
        defaultMessage: "B variant"
    },
    [Ab0.AB0_AB]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_AB",
        defaultMessage: "AB"
    },
    [Ab0.AB0_0]: {
        id: "ltx.phaseI.bloodGroup.ab0.AB0_0",
        defaultMessage: "0"
    }
};
exports.rhMessages = {
    [Rh.RH_POSITIVE]: {
        id: "ltx.phaseI.bloodGroup.rh.RH_POSITIVE",
        defaultMessage: "pozitív"
    },
    [Rh.RH_NEGATIVE]: {
        id: "ltx.phaseI.bloodGroup.rh.RH_NEGATIVE",
        defaultMessage: "negatív"
    }
};
const ab0 = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Ab0.AB0_A),
    schema_1.Schema.singleChoiceItem(Ab0.AB0_AVAR),
    schema_1.Schema.singleChoiceItem(Ab0.AB0_B),
    schema_1.Schema.singleChoiceItem(Ab0.AB0_BVAR),
    schema_1.Schema.singleChoiceItem(Ab0.AB0_AB),
    schema_1.Schema.singleChoiceItem(Ab0.AB0_0)
])
    .interpretation({ vocab: "ltx", code: "ab0" })
    .tag({ vocab: "snomed", code: "112143006" })
    .tag({ vocab: "loinc", code: "883-9" });
const rh = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Rh.RH_POSITIVE),
    schema_1.Schema.singleChoiceItem(Rh.RH_NEGATIVE)
])
    .interpretation({ vocab: "ltx", code: "rh" })
    .tag({ vocab: "snomed", code: "363783003" })
    .tag({ vocab: "loinc", code: "10331-7" });
const comment = schema_1.Schema.string()
    .optional()
    .interpretation({ vocab: "ltx", code: "comment_for_blood_group" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ ab0, rh, comment })
    .interpretation({ vocab: "ltx", code: "blood_group" })
    .tag({ vocab: "snomed", code: "365636006" })
    .tag({ vocab: "loinc", code: "34530-6" });
